export const MODAL_HEADER_TEST_ID = {
  closeButton: 'close-button',
  heading: 'modal-heading',
};
